import { render, staticRenderFns } from "./order-items.vue?vue&type=template&id=23c21463&scoped=true&"
import script from "./order-items.vue?vue&type=script&lang=js&"
export * from "./order-items.vue?vue&type=script&lang=js&"
import style0 from "./order-items.vue?vue&type=style&index=0&id=23c21463&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c21463",
  null
  
)

export default component.exports